<template>
	<a target="blank" href="http://somosfriday.com.br">
		<!-- Generator: Adobe Illustrator 21.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
		<svg  class="link-site" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
				viewBox="0 0 297.6 142.8" style="enable-background:new 0 0 297.6 142.8;" xml:space="preserve">
			<g>
				<g>
					<path class="st0" d="M1.8,75.3C6,63.2,20.4,35.9,33,15.7c-3.3-1.9-4.9-4.7-5.4-7.3c-0.4-1.9,0.4-2.7,3.2-2.7
						c8.3,0,14.5-0.9,21.3-2c5-0.9,9.7-1.4,13.2-1.4c6.9,0,10.9,2.9,12.9,7.7c0.7,1.6,0,3.2-3,3.2C67.8,13,60.8,14.6,47.1,17
						c-4.7,7.9-10.3,17.8-17,30.1c2.7-0.4,4.7-0.6,6.9-0.7c8.2-0.6,12,2.4,13.3,7c0.6,2,0.3,3.3-2.9,3.6c-6.6,0.6-16.8,1.9-24.6,3.9
						c-5.3,10.3-9.5,19.2-14.5,29.9c-0.9,1.9-2.9,2.3-4.9,1c-2-1.3-3.3-4.3-3.3-7.7C0.1,81.9,0.7,78.9,1.8,75.3z"/>
					<path class="st0" d="M75.6,32.8c0,2.7-1,6.9-2.6,11.5c3.4-0.9,7.3-2.9,11.6-6c2.4-1.7,3.9-2,5.7-0.1c2,2,4.2,5.7,4.2,9.2
						c0,1.7-0.7,3.7-2.3,5.6C84.5,61.7,76.3,73,76.3,81.5c0,3.7,1.1,6,3.2,6c4.9,0,10.6-8,15-17.9c1.1-2.6,3.2-2.7,4.4-0.1
						c1,2,1.1,5.4-0.4,9.3c-3.4,8.2-11.9,14.3-20.1,14.3c-8.7,0-13.5-6.2-13.5-13.9C65,70,72.6,59,79.7,50.3c-3.7,1.6-7.3,2.1-10.5,2.3
						C58.5,71.2,50.4,84.3,48.4,94.2c-0.6,2.6-2.4,3.9-5,1.1c-2.4-2.3-3.6-5.3-3.6-8.5c0-3.2,1-6.6,3-10.3c2.4-4.6,9.7-16.3,17.6-26.1
						c-1.7-1.6-2.7-3.4-2.7-5.3c0-7.3,9.2-17.5,13.6-17.5C74.3,27.8,75.6,29.5,75.6,32.8z"/>
				</g>
				<g>
					<path class="st0" d="M104.8,92.5c-8.7,0-12.6-5-12.6-12.2c0-2.7,0.6-5.7,1.7-9.5c3.6-10,12.7-26.6,18-34.1c2.1-2.9,3.9-3.2,5.7-1
						c2.7,2.9,3.9,9,0.1,16.2c-2.7,6.2-9.3,16.9-11.7,22.6c-1.3,3.3-2,6.3-2,8.6c0,2.3,0.6,3.6,2.1,3.6c5.7,0,13.2-9.6,17.6-19.3
						c1.1-2.6,3-2.3,4.3,0.3c1.3,2.4,1.1,6-0.7,9.7C123.1,86.5,113.2,92.5,104.8,92.5z M123.1,19.5c4,0,7.9,5.2,7.9,9.3
						c0,3.9-2.1,7.2-5.7,7.2c-4.6,0-8.4-4.3-8.4-8.7C116.8,23.2,119.8,19.5,123.1,19.5z"/>
					<path class="st0" d="M164.2,74.9c-1.7,3.7-2.6,6.9-2.6,9.2c0,2.1,0.6,3.2,1.9,3.2c5,0,14.7-12.8,19.6-22.2c3.7-4.3,4.7-5.6,6-3
						c0.7,1.3-2.8,11.6-4.7,15.6c-3.9,7.7-12.7,15.2-21.1,15.2c-7,0-11.7-2.4-12.9-8.7c-4.4,4.6-10,8.3-16.3,8.3
						c-8.3,0-12.9-6.2-12.9-14.6c0-6,2.6-13.9,7.6-21.2c11.2-16.2,23.1-22.9,30.5-22.9c4.9,0,8,2,9.2,5.7C175.7,25.9,185,9.7,189.7,3
						c2.6-3.6,4.6-3.3,6,0.1c0.7,1.7,1.3,3.6,1.3,5.6c0,3.9-1.9,9.5-5.6,16.2C183.1,40.7,171,60.7,164.2,74.9z M161.6,42.4
						c-4-0.1-13.5,8.6-21.1,20.6c-4.3,6.7-6.6,13.9-6.6,18.6c0,2.6,0.6,4.4,2.1,4.4c4.6,0,11.5-8,17.9-20.5
						C161.8,50.8,164.4,42.5,161.6,42.4z"/>
				</g>
			</g>
			<g>
				<path class="st0" d="M218.2,33.2c5.2,0,8.3,2.6,9.6,6.3l2.7-4.4c1.7-2.9,4.2-3,5.9-1c2.4,2.9,3.7,9.2,0,16.6
					c-3.7,7.9-15.8,23.5-15.8,33.1c0,2.1,0.6,3.4,2,3.4c5.2,0,12.3-9.7,17-19c1.6-2.9,2.9-3,4.3,0c0.6,1.3,1.4,5.2-0.6,9.3
					c-3.7,7.9-12.9,15.5-21.6,15.5c-7.2,0-11.3-3.7-12.5-9c-4.2,4-10.6,8.5-16.3,8.5c-8.4,0-13-6.2-13-14.6c0-6.2,2.6-14.2,7.7-21.3
					C199.2,39.9,210.9,33.2,218.2,33.2z M213.2,65.3c5.6-9.7,8.2-16.8,8.2-20.5c0-1.7-0.3-2.7-1.7-2.7c-2.9,0-12.7,9-20.1,20.8
					c-4.3,6.7-6.7,14.3-6.7,18.9c0,2.6,0.6,4.3,2,4.3C199.6,86.1,206.2,77.3,213.2,65.3z"/>
				<path class="st0" d="M295,76.3c-5.7,8.7-15.2,14-26.9,18.9c-7.9,18.9-17.6,41.8-30.1,46.5c-3.3,1.3-6.3,1.3-9.7-3.3
					c-2.1-3-4.3-7.3-4.3-11.9c0-1.7,0.4-4.2,1.3-6.7c4.4-12.3,16-21.1,29.9-26.6l2.1-5c-3.7,2.7-7.4,4-11.7,4
					c-7.2,0-10.3-5.4-10.3-11.5c0-3,0.6-6.4,1.9-10c3.3-9,10.3-23.5,19.2-35.7c1.9-2.4,4-2.6,5.6-0.3c1.4,2,2.7,4.6,2.7,6.9
					c0,3.6-1.7,7.7-5,13c-4.9,7.7-7.9,13.6-10.6,20.3c-2,5.2-3.3,10.9,0.4,10.9s10.2-8.5,17.2-20.3c9.6-16.2,13.5-24.9,16.9-30.1
					c2-2.6,3.9-2.9,5.4-1.3c2.1,2.1,2.7,4.3,2.7,7.3c0,2.9-0.7,6-2.6,9.6c-4.2,8-11.6,21.9-17.5,35.5c8.7-5.3,16.2-12.6,20.8-19
					c1.9-2.6,4-2.9,4.6-1C297.7,68.9,297.4,72.6,295,76.3z M236.7,119c-3.6,6.7-4.6,12.6-3.2,13.9c1,0.9,4-3.3,8-10.3
					c3-5.3,6.4-12.3,9.9-20.1C244.6,107.3,239.7,113.4,236.7,119z"/>
			</g>
		</svg>					
	</a>
</template>

<script>
export default {
	name: 'FridaySVG',
	data () {
		return {
			msg: 'Logo da Friday em formato SVG.'
		}
	}
}
</script>

<style lang="stylus">
	.link-site
		width 60px
		margin-left 5px
		margin-bottom -11px
		.st0
			fill #888
			transition 200ms all ease
		&:hover
			.st0
				fill #108ad6
</style>



// WEBPACK FOOTER //
// src/components/FridaySvg.vue